export class HoldingsEnvironment {
  public static getName = () => 'benzinga-holdings';
  public static getEnvironment = () => ({
    url: new URL('https://www.benzinga.com/api/sheets/holdings/list'),
  });
}
